window.Sq = window.Sq || {};
Sq.Shop = Sq.Shop || {};
$(() => Sq.Shop.WarrantyReasons.init());

Sq.Shop.WarrantyReasons = {
  utils: Sq.Shop.Utils,

  init() {
    if ($('#warranty-reasons-page').length === 0) {
      return;
    }

    this.getHtml();
    this.bindEvents();
    this.createVariable();
    this.validateForm();
  },

  getHtml() {
    this.$form = $('#warranty-reasons-form');
    this.$inputs = this.$form.find('input, select, textarea');
    this.$inputs = this.$inputs.filter((idx, el) => {
      return $(el).closest('.field').data('sq.field') !== undefined;
    });
  },

  bindEvents() {
    this.$form.on('submit', (e) => this.onFormSubmit(e));
    this.$inputs.on('change', () => this.validateForm());
  },

  createVariable() {
    this.errors = new Array(this.$inputs.length);
  },

  onFormSubmit(e) {
    e.preventDefault();
    this.validateForm();
    this.updateView();
    if (this.findFirstError() === undefined) {
      this.$form.off('submit');
      this.$form.submit();
    }
  },

  validateForm() {
    this.$inputs.each((idx, el) => {
      this.validateField(idx, el);
    });
  },

  validateField(idx, el) {
    if (el.name === 'warranty_items[][serial_number]') {
      this.validateSerialField(idx, el);
    } else {
      this.validateTextOrSelect(idx, el);
    }
  },

  validateTextOrSelect(idx, el) {
    const $el = $(el);
    let value = ($el.val() || '').trim();
    const title = $el.data('title');

    const isEmpty = value === '';
    const isRequired = $el.prop('required');

    const pattern = $el.attr('pattern');
    const flags = $el.attr('data-pattern-flags');
    let matcher = null;
    if (pattern) {
      matcher = new RegExp(pattern, flags);
    }

    const stripNonDigits = $el.attr('data-strip-non-digits') === 'true';
    if (stripNonDigits) {
      value = value.replace(/\D+/g, '');
    }

    let isValid = true;
    if (isRequired && isEmpty) {
      isValid = false;
    }
    if (!isEmpty && matcher && !matcher.test(value)) {
      isValid = false;
    }

    if (isValid) {
      this.clearError(idx, $el);
    } else {
      this.setError(idx, $el, title);
    }
  },

  validateSerialField(idx, el) {
    const $el = $(el);
    const title = $el.data('title');
    const isRequired = $el.prop('required');
    const product_name = $el.closest('li').find('input:hidden').prop('value');
    const serial_number = $el.val();

    if (isRequired && !this.validateUniqueSerial(serial_number)) {
      this.setError(idx, $el, title);
    } else if (!isRequired && serial_number.length === 0) {
      this.clearError(idx, $el);
    } else {
      $.ajax({
        type: 'POST',
        url: 'warranty_serial_validation',
        data: {
          name: product_name,
          serial: serial_number,
        },
        success: (response) => {
          if (response.error) {
            this.setError(idx, $el, response.error);
          } else {
            this.clearError(idx, $el);
          }

          if (this.isLiveValidatingView()) {
            this.updateView();
          }
        },
      });
    }
  },

  validateUniqueSerial(serial) {
    let count = 0;
    this.$inputs.each(function () {
      if ($(this).val() === serial) {
        count++;
      }
    });
    return count === 1;
  },

  isLiveValidatingView() {
    return this.$form.attr('data-is-live-validating') === 'true';
  },

  enableLiveValidatingView() {
    this.$form.attr('data-is-live-validating', true);
    this.$inputs.on('change', () => {
      this.updateView();
    });
  },

  findFirstError() {
    let index = undefined;
    $(this.errors).each((idx, error) => {
      if (error.err_msg) {
        index = idx;
        return false;
      } else {
        return true;
      }
    });
    return index;
  },

  setError(idx, el, err_msg) {
    this.errors[idx] = { el, err_msg };
  },

  clearError(idx, el) {
    this.errors[idx] = { el, err_msg: undefined };
  },

  updateView() {
    this.errors.forEach((error) => {
      if (error.err_msg) {
        $(error.el).closest('.field').data('sq.field').toggleError(true);
        this.$form.data('sq.form').disable();
      } else {
        $(error.el).closest('.field').data('sq.field').toggleError(false);
      }
    });

    const firstErrorIdx = this.findFirstError();
    if (firstErrorIdx !== undefined) {
      this.utils.flashBanner().update({
        message: this.errors[firstErrorIdx].err_msg,
        state: 'error',
      });
      if (!this.isLiveValidatingView()) {
        this.enableLiveValidatingView();
      }
    } else {
      this.$form.data('sq.form').enable();
      this.utils.flashBanner().hide();
    }
  },
};
